// Accessories Data - Modal Pop-up Content
// Categories: adhesives, frames, ancillaries

export const accessoryCategories = {
  adhesives: {
    label: "Bonding Solution",
    ctaPrimary: "Request Sample",
    ctaSecondary: "Request Tester"
  },
  frames: {
    label: "Preconfigured Frame",
    ctaPrimary: "Request Quote",
    ctaSecondary: "Contact Sales"
  },
  ancillaries: {
    label: "Accessory Component",
    ctaPrimary: "Add to Quote",
    ctaSecondary: "Contact Sales"
  }
};

export const accessories = [
  // ==================== ADHESIVES ====================
  {
    id: "440-gldstk",
    name: "440-GLDSTK",
    category: "adhesives",
    descriptor: "Multi-purpose, non-toxic adhesive for indoor flooring and surface applications.",
    image: "/Assets/images/accessories/440-GLDSTK/440-GLDSTK.jpg",
    pdfSheet: "/Assets/pdf/accessories/PS_ATS_440-GLDSTK.pdf",
    bestFor: [
      "Sheet vinyl and VCT installations",
      "Smooth-backed sheet and roll goods carpeting",
      "General indoor bonding applications"
    ],
    performanceHighlights: [
      "Multi-purpose formulation for versatile use",
      "Non-toxic and low-odor for indoor environments",
      "Provides reliable adhesion across common flooring materials"
    ],
    applicationDetails: [
      "Indoor use only",
      "Smooth-backed materials",
      "Trowel-applied adhesive"
    ],
    worksWith: ["Sheet Vinyl", "VCT", "Roll Goods Carpeting"],
    whyUseThis: [
      "Versatile multi-purpose adhesive",
      "Safe for indoor environments",
      "Reliable bonding performance"
    ]
  },
  {
    id: "2420",
    name: "2420",
    category: "adhesives",
    descriptor: "Universal white acrylic adhesive with antimicrobial protection for resilient indoor flooring.",
    image: "/Assets/images/accessories/2420/2420.jpg",
    pdfSheet: "/Assets/pdf/accessories/PS_ATS_2420.pdf",
    bestFor: [
      "Luxury vinyl plank and tile installations",
      "Bitumen-backed carpet tile",
      "Indoor flooring applications requiring added protection"
    ],
    performanceHighlights: [
      "Acrylic-based formula",
      "Built-in antimicrobial protection",
      "Designed for resilient flooring materials",
      "Clean white finish"
    ],
    applicationDetails: [
      "Indoor use only",
      "Trowel-applied adhesive"
    ],
    worksWith: ["LVP", "LVT", "Bitumen-backed Carpet Tile"],
    whyUseThis: [
      "Antimicrobial protection built-in",
      "Versatile for resilient flooring",
      "Professional white finish"
    ]
  },
  {
    id: "631-1100",
    name: "631-1100",
    category: "adhesives",
    descriptor: "All-weather, water-based adhesive designed for outdoor carpet installations.",
    image: "/Assets/images/accessories/631-1100/631-1100.jpg",
    pdfSheet: "/Assets/pdf/accessories/PS_ATS_631-1100.pdf",
    bestFor: [
      "Rubber-backed sheet and roll goods carpeting (non-vinyl)",
      "Outdoor installations",
      "Weather-resistant bonding applications"
    ],
    performanceHighlights: [
      "All-weather formulation",
      "Water-based adhesive system",
      "Designed for rubber-backed materials"
    ],
    applicationDetails: [
      "Outdoor use",
      "Trowel-applied adhesive"
    ],
    worksWith: ["Outdoor Carpet", "Rubber-backed Roll Goods"],
    whyUseThis: [
      "Designed for outdoor conditions",
      "Weather-resistant bonding",
      "Water-based and durable"
    ]
  },
  {
    id: "lock-p799",
    name: "Lock P799 I/O Rubber",
    category: "adhesives",
    descriptor: "Moisture-cured polyurethane adhesive for high-performance rubber flooring applications.",
    image: "/Assets/images/accessories/Lock-P799-I-O-Rubber/LockP799_IORubber.png",
    pdfSheet: "/Assets/pdf/accessories/PS_ATS_Lock-P799.pdf",
    bestFor: [
      "Recycled rubber flooring installations",
      "High-performance indoor applications",
      "Strong, durable bonding"
    ],
    performanceHighlights: [
      "Moisture-cured polyurethane formula",
      "Exceptional bond strength for rubber materials",
      "Durable long-term performance"
    ],
    applicationDetails: [
      "Moisture-cured",
      "Trowel-applied adhesive",
      "Rubber flooring compatibility"
    ],
    worksWith: ["Recycled Rubber Flooring", "Rubber Tiles", "Rubber Rolls"],
    whyUseThis: [
      "Superior bond for rubber flooring",
      "Long-lasting durability",
      "High-performance formula"
    ]
  },

  // ==================== PRE-DRILLED ALUMINUM FRAMES ====================
  {
    id: "threshold-001",
    name: "THRESHOLD-001",
    category: "frames",
    descriptor: "Mill-finished, low-profile pre-drilled aluminum frame designed for clean threshold installations.",
    image: "/Assets/images/accessories/THRESHOLD-001/Threshold_001.svg",
    svgProfile: null,
    pdfSheet: "/Assets/pdf/accessories/PS_FTS_Threshold-001.pdf",
    details: {
      dimensions: "2.5\" W x 8' L x 0.19\" H",
      material: "Aluminum, mill finish",
      drilling: "Pre-drilled, 10 holes",
      profile: "Low profile"
    },
    whyUseThis: [
      "Creates a clean transition at threshold edges",
      "Low-profile design minimizes visibility",
      "Faster, more consistent installation"
    ],
    worksWith: ["Entry Grid Systems", "Carpet Tile", "LVT"]
  },
  {
    id: "ramp-5207",
    name: "RAMP-5207",
    category: "frames",
    descriptor: "Mill-finished pre-drilled aluminum ramp frame designed for smooth surface transitions.",
    image: "/Assets/images/accessories/Ramp-5207/RAMP_5207.svg",
    svgProfile: null,
    pdfSheet: "/Assets/pdf/accessories/PS_FTS_RAMP-5207.pdf",
    details: {
      dimensions: "2\" W x 8' L x 0.312\" H",
      material: "Aluminum, mill finish",
      drilling: "Pre-drilled, 10 holes",
      profile: "Ramp profile"
    },
    whyUseThis: [
      "Smooth transition between surface heights",
      "Reduces trip hazards",
      "Faster, consistent installation"
    ],
    worksWith: ["Entry Grid Systems", "Floor Transitions"]
  },
  {
    id: "lvt-1-8-0",
    name: "LVT 1-8-0",
    category: "frames",
    descriptor: "Low-profile pre-drilled aluminum frame designed for LVT flooring applications.",
    image: "/Assets/images/accessories/LVT_1-8-0/LVT_180.svg",
    svgProfile: null,
    pdfSheet: "/Assets/pdf/accessories/PS_FTS_LVT-180.pdf",
    details: {
      dimensions: "1.5\" W x 8' L x 0.125\" H",
      material: "Aluminum, mill finish",
      drilling: "Pre-drilled, 16 holes",
      profile: "Low profile"
    },
    whyUseThis: [
      "Designed for LVT installations",
      "Minimal transition height",
      "Increased fastening points for stability"
    ],
    worksWith: ["LVT", "Luxury Vinyl Plank", "Vinyl Tile"]
  },
  {
    id: "rlpx-ramp",
    name: "RLPX Ramp",
    category: "frames",
    descriptor: "Mill-finished pre-drilled aluminum ramp frame for extended-length surface transitions.",
    image: "/Assets/images/accessories/RLPX-Ramp/RLPX.svg",
    svgProfile: null,
    pdfSheet: "/Assets/pdf/accessories/PS_FTS_RAMP-RLPX.pdf",
    details: {
      dimensions: "1.56\" W x 12' L x 0.5\" H",
      material: "Aluminum, mill finish",
      drilling: "Pre-drilled",
      profile: "Ramp profile"
    },
    whyUseThis: [
      "Ideal for longer transition spans",
      "Accommodates greater height differences",
      "Smooth continuous transition"
    ],
    worksWith: ["Extended Floor Transitions", "Carpet to Hard Surface"]
  },
  {
    id: "overlap-ramp-81611",
    name: "OVERLAP Ramp-81611",
    category: "frames",
    descriptor: "Mill-finished pre-drilled aluminum overlap ramp for secure transitions between surfaces.",
    image: "/Assets/images/accessories/OVERLAP-Ramp-81611/RAMP_81611.svg",
    svgProfile: null,
    pdfSheet: "/Assets/pdf/accessories/PS_FTS_RAMP-81611.pdf",
    details: {
      dimensions: "2.75\" W x 8' L x 0.457\" H",
      material: "Aluminum, mill finish",
      drilling: "Pre-drilled, 10 holes",
      profile: "Overlap ramp profile"
    },
    whyUseThis: [
      "Creates a secure overlap between adjoining surfaces",
      "Helps bridge uneven edges",
      "Faster, consistent installation"
    ],
    worksWith: ["Uneven Surface Transitions", "Entry Systems"]
  },
  {
    id: "smf-17",
    name: "SMF-17",
    category: "frames",
    descriptor: "Mill-finished low-profile pre-drilled aluminum frame for secure surface-mounted applications.",
    image: "/Assets/images/accessories/SMF-17/SMF_17.svg",
    svgProfile: null,
    pdfSheet: "/Assets/pdf/accessories/PS_FTS_SMF-17.pdf",
    details: {
      dimensions: "2.25\" W x 8' L x 0.438\" H",
      material: "Aluminum, mill finish",
      drilling: "Pre-drilled, 10 holes",
      profile: "Low profile"
    },
    whyUseThis: [
      "Provides stable surface-mounted support",
      "Wider profile improves coverage and hold",
      "Fast, consistent installation"
    ],
    worksWith: ["Surface-mounted Systems", "Entry Grids"]
  },

  // ==================== SURFACE-MOUNTED ANCILLARIES ====================
  {
    id: "h-section",
    name: "H-Section",
    category: "ancillaries",
    descriptor: "Aluminum divider with PVC insert for seamless front-to-back matting installations.",
    image: "/Assets/images/accessories/H-Section/H-SEC.svg",
    svgProfile: null,
    diagramImage: "/Assets/images/accessories/H-Section/H-SEC_diagram.png",
    pdfSheet: "/Assets/pdf/accessories/PS_ACTS_H-Section.pdf",
    details: {
      dimensions: "0.5\" W x 9' 10\" L x 0.4375\" H",
      material: "Aluminum with matching PVC insert"
    },
    function: [
      "Acts as an invisible divider between adjoining mat sections",
      "Creates a clean continuous transition",
      "Maintains alignment"
    ],
    whereUsed: [
      "Front-to-back installations",
      "14mm / 10.5mm matting"
    ],
    worksWith: ["14mm Matting", "10.5mm Matting", "Entry Grid Systems"]
  },
  {
    id: "u-section",
    name: "U-Section",
    category: "ancillaries",
    descriptor: "Mill-finished aluminum section used as a front-to-back frame or divider for matting systems.",
    image: "/Assets/images/accessories/U-Section/U-SEC.svg",
    svgProfile: null,
    diagramImage: "/Assets/images/accessories/U-Section/U-SEC_diagram.png",
    pdfSheet: "/Assets/pdf/accessories/PS_ACTS_U-Section.pdf",
    details: {
      dimensions: "0.75\" W x 9' 10\" L x 0.5625\" H",
      material: "Aluminum, mill finish",
      drilling: "Pre-drilled"
    },
    function: [
      "Frames or divides matting sections front-to-back",
      "Provides structural edge support",
      "Helps contain and secure matting"
    ],
    whereUsed: [
      "14mm matting"
    ],
    worksWith: ["14mm Matting", "Entry Grid Systems"]
  },
  {
    id: "t-section",
    name: "T-Section",
    category: "ancillaries",
    descriptor: "Mill-finished aluminum divider for large left-to-right matting installations.",
    image: "/Assets/images/accessories/T-Section/T-SEC.svg",
    svgProfile: null,
    diagramImage: "/Assets/images/accessories/T-Section/T-SEC_diagram.png",
    pdfSheet: "/Assets/pdf/accessories/PS_ACTS_T-Section.pdf",
    details: {
      dimensions: "1.0625\" W x 9' 10\" L x 0.625\" H",
      material: "Aluminum, mill finish",
      drilling: "Pre-drilled"
    },
    function: [
      "Divides matting sections across wide layouts",
      "Maintains alignment over larger spans",
      "Provides structural separation"
    ],
    whereUsed: [
      "Large left-to-right layouts",
      "14mm matting"
    ],
    worksWith: ["14mm Matting", "Large Format Installations"]
  },
  {
    id: "edge-r",
    name: "Edge R",
    category: "ancillaries",
    descriptor: "Mill-finished aluminum edge cap for securing and finishing exposed matting ends.",
    image: "/Assets/images/accessories/EDGE-R/Edge_R.svg",
    svgProfile: null,
    diagramImage: "/Assets/images/accessories/EDGE-R/edge-R_diagram.png",
    pdfSheet: "/Assets/pdf/accessories/PS_ACTS_Edge-R.pdf",
    details: {
      dimensions: "0.75\" W x 9' 10\" L x 0.5625\" H",
      material: "Aluminum, mill finish",
      drilling: "Pre-drilled"
    },
    function: [
      "Caps and secures exposed matting edges",
      "Prevents movement at system boundaries",
      "Creates a clean finished edge"
    ],
    whereUsed: [
      "Left and right extremities of wells",
      "14mm matting"
    ],
    worksWith: ["14mm Matting", "Entry Grid Systems"]
  },
  {
    id: "edge-z",
    name: "Edge Z",
    category: "ancillaries",
    descriptor: "Mill-finished aluminum edge for finishing matting installations alongside ceramic tile.",
    image: "/Assets/images/accessories/EDGE-Z/Edge_Z.svg",
    svgProfile: null,
    diagramImage: "/Assets/images/accessories/EDGE-Z/Edge-Z_diagram.png",
    pdfSheet: "/Assets/pdf/accessories/PS_ACTS_Edge-Z.pdf",
    details: {
      dimensions: "1.3125\" W x 12' L x 0.5\" H",
      material: "Aluminum, mill finish",
      drilling: "Pre-drilled"
    },
    function: [
      "Provides a clean transition between matting and ceramic tile",
      "Caps and secures exposed edges",
      "Aligns matting height with surrounding flooring"
    ],
    whereUsed: [
      "Left and right extremities",
      "10.5mm matting",
      "Adjacent to ceramic tile"
    ],
    worksWith: ["10.5mm Matting", "Ceramic Tile Transitions"]
  },
  {
    id: "tlp-section",
    name: "TLP Section",
    category: "ancillaries",
    descriptor: "Mill-finished aluminum divider for large left-to-right installations of 10.5mm matting.",
    image: "/Assets/images/accessories/TLP-Section/TLP-SEC.svg",
    svgProfile: null,
    diagramImage: "/Assets/images/accessories/TLP-Section/TLP-SEC_diagram.png",
    pdfSheet: "/Assets/pdf/accessories/PS_ACTS_TLP-Section.pdf",
    details: {
      dimensions: "1.3125\" W x 8' L x 0.5\" H",
      material: "Aluminum, mill finish",
      drilling: "Pre-drilled"
    },
    function: [
      "Divides matting sections across wide layouts",
      "Maintains alignment over larger spans",
      "Provides structural separation"
    ],
    whereUsed: [
      "Large layouts",
      "10.5mm matting"
    ],
    worksWith: ["10.5mm Matting", "Large Format Installations"]
  },
  {
    id: "ulp-section",
    name: "ULP Section – Low Profile",
    category: "ancillaries",
    descriptor: "Low-profile aluminum frame/divider for front-to-back installations of 10.5mm matting.",
    image: "/Assets/images/accessories/Low-Profile-ULP-Section/Edge_ULP.svg",
    svgProfile: null,
    diagramImage: "/Assets/images/accessories/Low-Profile-ULP-Section/Edge-ULP_diagram.png",
    pdfSheet: "/Assets/pdf/accessories/PS_ACTS_ULP-Section.pdf",
    details: {
      dimensions: "0.75\" W x 8' L x 0.4375\" H",
      material: "Aluminum, mill finish",
      drilling: "Pre-drilled",
      profile: "Low profile"
    },
    function: [
      "Frames or divides matting sections front-to-back",
      "Provides structural support with a low profile",
      "Helps secure and align matting"
    ],
    whereUsed: [
      "Low-profile applications",
      "10.5mm matting"
    ],
    worksWith: ["10.5mm Matting", "Low-profile Installations"]
  },
  {
    id: "edge-rlpx",
    name: "Edge RLPX",
    category: "ancillaries",
    descriptor: "Mill-finished aluminum transition edge for connecting 10.5mm matting to carpet tiles.",
    image: "/Assets/images/accessories/EDGE-RLPX/edge-RLPX.svg",
    svgProfile: null,
    diagramImage: null,
    pdfSheet: "/Assets/pdf/accessories/PS_ACTS_Edge-RLPX.pdf",
    details: {
      dimensions: "1.56\" W x 12' L x 0.5\" H",
      material: "Aluminum, mill finish",
      drilling: "Pre-drilled"
    },
    function: [
      "Transitions between matting and carpet tile",
      "Provides a smooth secure edge connection",
      "Aligns differing material heights"
    ],
    whereUsed: [
      "10.5mm matting to carpet tile"
    ],
    worksWith: ["10.5mm Matting", "Carpet Tile Transitions"]
  },
  {
    id: "edge-rlp",
    name: "Low-Profile Edge RLP",
    category: "ancillaries",
    descriptor: "Mill-finished low-profile aluminum edge cap for securing and finishing matting ends.",
    image: "/Assets/images/accessories/Low-Profile-EDGE-RLP/edge-RLP.svg",
    svgProfile: null,
    diagramImage: "/Assets/images/accessories/Low-Profile-EDGE-RLP/Edge-RLP_diagram.png",
    pdfSheet: "/Assets/pdf/accessories/PS_ACTS_LP-Edge-RLP.pdf",
    details: {
      dimensions: "1\" W x 8' L x 0.50\" H",
      material: "Aluminum, mill finish",
      drilling: "Pre-drilled",
      profile: "Low-profile edge"
    },
    function: [
      "Caps and secures exposed matting edges",
      "Maintains a low minimal edge profile",
      "Provides a clean finished perimeter"
    ],
    whereUsed: [
      "Left and right extremities of wells",
      "14mm matting"
    ],
    worksWith: ["14mm Matting", "Low-profile Edge Finishing"]
  },
  {
    id: "edge-j",
    name: "Edge J",
    category: "ancillaries",
    descriptor: "Mill-finished aluminum edge cap designed for terminating matting installations against walls.",
    image: "/Assets/images/accessories/EDGE-J/Edge_J.svg",
    svgProfile: null,
    diagramImage: "/Assets/images/accessories/EDGE-J/edge-J_diagram.png",
    pdfSheet: "/Assets/pdf/accessories/PS_ACTS_Edge-J.pdf",
    details: {
      dimensions: "1.5\" W x 10' L x 0.625\" H",
      material: "Aluminum, mill finish",
      drilling: "Pre-drilled"
    },
    function: [
      "Caps and secures matting edges where they meet a wall",
      "Creates a clean finished transition to vertical surfaces",
      "Prevents edge movement at wall boundaries"
    ],
    whereUsed: [
      "Perimeter edges against walls",
      "Left and right extremities of wells",
      "14mm matting"
    ],
    worksWith: ["14mm Matting", "Wall Terminations"]
  }
];

// Helper function to get accessory by ID
export const getAccessoryById = (id) => {
  return accessories.find(acc => acc.id === id);
};

// Helper function to get accessories by category
export const getAccessoriesByCategory = (category) => {
  return accessories.filter(acc => acc.category === category);
};

// Get all adhesives
export const adhesives = getAccessoriesByCategory('adhesives');

// Get all frames
export const frames = getAccessoriesByCategory('frames');

// Get all ancillaries
export const ancillaries = getAccessoriesByCategory('ancillaries');
